import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "cookie_consent_v1";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    // Hide on admin panel
    if (typeof window !== "undefined" && window.location.pathname.startsWith("/painel")) {
      setIsAdmin(true);
      return;
    }
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) {
        // Small delay so it doesn't compete with pixels / hero animations
        const t = setTimeout(() => setVisible(true), 1200);
        return () => clearTimeout(t);
      }
    } catch (_) {
      setVisible(true);
    }
  }, []);

  const persist = (value) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ status: value, ts: new Date().toISOString() })
      );
    } catch (_) {}
    setVisible(false);
  };

  if (isAdmin || !visible) return null;

  return (
    <div
      className="fixed bottom-3 left-3 right-3 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[9999] animate-fade-in"
      data-testid="cookie-consent-banner"
    >
      <div className="bg-white border border-[#E2E8F0] shadow-2xl rounded-2xl p-4 md:p-5">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-full bg-[#0047FF]/10 flex items-center justify-center flex-shrink-0">
            <Cookie size={18} className="text-[#0047FF]" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2">
              <p className="text-sm font-bold text-[#0F172A]">Aviso de Cookies</p>
              <button
                onClick={() => persist("rejected")}
                className="text-[#94A3B8] hover:text-[#0F172A] -mt-1 -mr-1 p-1"
                aria-label="Fechar"
                data-testid="cookie-close-btn"
              >
                <X size={16} />
              </button>
            </div>
            <p className="text-xs text-[#64748B] leading-relaxed mt-1">
              Usamos cookies para melhorar sua experiência, personalizar conteúdo e analisar o tráfego, conforme nossa{" "}
              <a href="/privacidade" className="text-[#0047FF] font-semibold hover:underline">
                Política de Privacidade
              </a>{" "}
              (LGPD).
            </p>
            <div className="flex items-center gap-2 mt-3">
              <button
                onClick={() => persist("accepted")}
                className="flex-1 bg-[#0047FF] hover:bg-[#0038CC] text-white text-xs font-bold px-4 py-2.5 rounded-lg transition-colors"
                data-testid="cookie-accept-btn"
              >
                Aceitar todos
              </button>
              <button
                onClick={() => persist("rejected")}
                className="flex-1 bg-white border border-[#E2E8F0] text-[#475569] hover:bg-[#F8FAFC] text-xs font-semibold px-4 py-2.5 rounded-lg transition-colors"
                data-testid="cookie-reject-btn"
              >
                Rejeitar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
